import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import { useParams } from "react-router-dom";
import { E2DynamicDataEditCard } from "./edit_card";

export const E2DynamicDataEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <E2DynamicDataEditCard
          id={Number(id)}
          client={Clients.E2}
          table_name={`${Tables.E2_DYNAMIC_DATA}`}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.E2}
          audit_table_name={`${Tables.E2_DYNAMIC_DATA}`}
        />
      </div>
    </div>
  );
};
